import './index.erb';
import './index.rb';


$(document).on('turbolinks:load', () => {
  $('#js-paid-button').on('click', () => {
    Thor.UserPreference.update(null, {
      data: {
        user_preferences: {
          confirmed_payment_id: gon.ticket_payment_id
        }
      }
    })
      .then(() => {
        Turbolinks.visit(window.location.toString());
      })
      .catch(() => {
        toastr.error(
          'Não foi possível processar sua confirmação. Por favor, tente novamente.'
        );
      });
  });
});
